import axios from "axios";
import { useToast } from "vue-toastification";
import router from "../../router";
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();

function redirectToPath() {
	const redirect_path = localStorage.getItem("redirect");
	const redirect_hash = cookies.get("hash");
	const redirect_params = localStorage.getItem("redirect_params");
	router.push({ name: redirect_path ? redirect_path : "Home", hash: redirect_hash, params: JSON.parse(redirect_params) });
	localStorage.removeItem("redirect");
	localStorage.removeItem("redirect_params");
	cookies.remove("hash");
}

export default {
	namespaced: true,
	state: {
		user: {
			username: "",
			email: "",
			address: {
				complete_address: "",
				lat: "",
				lng: "",
			},
			phone: "",
		},
		isLoggedIn: false,
		status: {
			fetchUser: {
				loading: false,
				error: "",
			},
			updateUserDetails: {
				loading: false,
				error: "",
			},
			login: {
				loading: false,
				error: "",
			},
			register: {
				loading: false,
				error: "",
			},
			login_meta_data: {
				loading: false,
				metadata: "",
			},
			register_meta_data: {
				loading: false,
				metadata: "",
			},
		},
	},
	getters: {
		status: (state) => state.status,
		user: (state) => state.user,
		isLoggedIn: (state) => state.isLoggedIn,
	},
	actions: {
		async fetchUser({ commit }) {
			commit("setLoading", {
				dataName: "fetchUser",
				status: true,
			});
			let token = localStorage.getItem("token");
			if (token) {
				try {
					let { data } = await axios.get(process.env.VUE_APP_API_URL + "/api/user", {
						headers: {
							Authorization: `Bearer ${token}`,
						},
					});
					commit("setLoading", {
						dataName: "fetchUser",
						status: false,
					});
					// console.log(data);
					commit("setUserDetails", data);
				} catch (error) {
					commit("setLoading", {
						dataName: "fetchUser",
						status: false,
					});
					commit("logout");
				}
			} else {
				commit("setLoading", {
					dataName: "fetchUser",
					status: false,
				});
				commit("logout");
			}
		},

		async login({ commit }, loginDetails) {
			commit("setLoading", {
				dataName: "login",
				status: true,
			});
			try {
				let { data } = await axios.post(
					process.env.VUE_APP_API_URL + "/api/signin",
					loginDetails,
					{
						headers: {
							session_id: localStorage.getItem("session_id"),
						},
					}
				);
				// console.log("Log In", data);
				if (data.token) {
					localStorage.setItem("token", data.token);
					redirectToPath()
					this.dispatch("auth/fetchUser");
					this.dispatch("cart/fetchCart");
					this.dispatch("cat/fetchCategories");
					commit("setMetaData", { dataName: "login_meta_data", metadata: "" });
				} else {
					if (data.status === "error") {
						useToast().error(data.message, { timeout: 3000 });
					}
					commit("setMetaData", { dataName: "login_meta_data", metadata: data });
				}
				commit("setError", {
					dataName: "login",
					error: "",
				});
				commit("setLoading", {
					dataName: "login",
					status: false,
				});
			} catch (error) {
				commit("setLoading", {
					dataName: "login",
					status: false,
				});
				commit("setError", {
					dataName: "login",
					error: error.response.data,
				});
				if (error.response.data.nokey) {
					useToast().error(error.response.data.nokey, {timeout: 3000});
				}
			}
		},

		async register({ commit }, regiserDetails) {
			// console.log(regiserDetails);
			commit("setError", {
				dataName: "register",
				error: "",
			});
			commit("setLoading", {
				dataName: "register",
				status: true,
			});
			try {
				let { data } = await axios.post(
					process.env.VUE_APP_API_URL + "/api/create-account",
					regiserDetails,
					{
						headers: {
							session_id: localStorage.getItem("session_id"),
						},
					}
				);
				commit("setLoading", {
					dataName: "register",
					status: false,
				});
				if (data.token) {
					commit("setMetaData", { dataName: "register_meta_data", metadata: "" });
					localStorage.setItem("token", data.token);
					redirectToPath()
					this.dispatch("auth/fetchUser");
				}
				// console.log(data);
				commit("setMetaData", { dataName: "register_meta_data", metadata: data });
			} catch (error) {
				commit("setLoading", {
					dataName: "register",
					status: false,
				});
				commit("setError", {
					dataName: "register",
					error: error.response.data,
				});
				console.log(error);
			}
		},
		async logout({ commit }) {
			commit("setLoading", {
				dataName: "fetchUser",
				status: true,
			});
			let token = localStorage.getItem("token");
			if (token) {
				try {
					let res = await axios.get(process.env.VUE_APP_API_URL + "/api/sign-out", {
						headers: {
							Authorization: `Bearer ${token}`,
						},
					});
					localStorage.removeItem("session_id");
					// remove session_id from local storage
					// console.log(res.data);
				} catch (error) {
					console.log(error);
				}
			}
			commit("setLoading", {
				dataName: "fetchUser",
				status: false,
			});
			commit("logout");
			this.dispatch("cart/clearCart");
			router.push({ name: "Home" });
		},
		updateUserDetails({ commit }, UserDetails) {
			commit("updateUserDetails", UserDetails);
		},

		setUserDetails({ commit }, UserDetails) {
			commit("setUserDetails", UserDetails);
		},
	},
	mutations: {
		setLoading: (state, { dataName, status }) => {
			state.status[dataName].loading = status;
		},
		setError: (state, { dataName, error }) => {
			state.status[dataName].error = error;
		},
		setMetaData: (state, { dataName, metadata }) => {
			state.status[dataName].metadata = metadata;
		},
		updateUserDetails: (state, payload) => {
			state.user = {
				...state.user,
				...payload,
			};
			state.user.username = payload.name;
			state.user.userdetails = {
				...state.user.userdetails,
				address: payload.address,
				latitude: payload.latitude,
				longitude: payload.longitude,
				phone_no: payload.phone_no,
			};
			state.isLoggedIn = true;
		},
		setUserDetails: (state, payload) => {
			state.user = payload;
			state.isLoggedIn = true;
		},
		logout: (state) => {
			localStorage.removeItem("token");
			(state.user = {
				username: "",
				email: "",
				address: {
					complete_address: "",
					lat: "",
					lng: "",
				},
			}),
				(state.isLoggedIn = false);
		},
	},
};
